import { type ReactNode } from 'react';
import { cn } from '@/lib/utils';

/** หัวการ์ดแบบเดียวกันทุกใบ — ไอคอน + หัวข้อ + คำอธิบาย + (ถ้ามี) ข้อความเล่าเรื่อง */
export function StoryCardHeader({
  icon,
  title,
  subtitle,
  narrative,
  className,
}: Readonly<{
  icon: ReactNode;
  title: string;
  subtitle: string;
  narrative?: string;
  className?: string;
}>) {
  return (
    <div
      className={cn(
        'flex flex-col gap-2 rounded-2xl border border-primary/20 bg-background/40 px-4 py-3 shadow-sm sm:px-5 sm:py-4 mix-blend-multiply dark:mix-blend-normal',
        className
      )}
    >
      <div className="flex items-center gap-3">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-primary/15 text-primary">
          {icon}
        </div>
        <div className="min-w-0">
          <h2 className="text-lg font-bold text-foreground sm:text-xl">
            {title}
          </h2>
          <p className="text-xs text-muted-foreground">{subtitle}</p>
        </div>
      </div>
      {narrative ? (
        <p className="text-sm leading-relaxed text-muted-foreground border-t border-border/40 pt-3">
          {narrative}
        </p>
      ) : null}
    </div>
  );
}
